import { create } from "zustand";
import { GameMetadataTabsEnum } from "../context/types";

export type MetadataStore = {
  metadataTab: GameMetadataTabsEnum;
  setMetadataTab: (value: GameMetadataTabsEnum) => void;

  gameDescription: string;
  setGameDescription: (value: string) => void;

  gameOptimisedDescription: string;
  setGameOptimisedDescription: (value: string) => void;

  gameShortDescription: string;
  setGameShortDescription: (value: string) => void;

  features: string[];
  setFeatures: (features: string[]) => void;

  volatility: string | null;
  setVolatility: (value: string | null) => void;

  rtpExact: string[];
  setRtpExact: (value: string[]) => void;

  paylines: string;
  setPaylines: (value: string) => void;

  jackpotType: string[];
  setJackpotType: (jackpotType: string[]) => void;

  languageSupport: string[];
  setLanguageSupport: (language: string[]) => void;

  reels: string;
  setReels: (value: string) => void;

  rows: string;
  setRows: (value: string) => void;

  releaseDate: string;
  setReleaseDate: (value: string) => void;

  autoplay: string | null;
  setAutoplay: (value: string | null) => void;

  minStake: string;
  setMinStake: (value: string) => void;

  maxStake: string;
  setMaxStake: (value: string) => void;

  maxWin: string;
  setMaxWin: (value: string) => void;
};

export const useMetadata = create<MetadataStore>((set) => ({
  metadataTab: GameMetadataTabsEnum.GENERAL,
  setMetadataTab: (value) => set({ metadataTab: value }),

  gameDescription: "",
  setGameDescription: (value) => set({ gameDescription: value }),

  gameOptimisedDescription: "",
  setGameOptimisedDescription: (value) =>
    set({ gameOptimisedDescription: value }),

  gameShortDescription: "",
  setGameShortDescription: (value) => set({ gameShortDescription: value }),

  features: [],
  setFeatures: (features) => set({ features }),

  volatility: null,
  setVolatility: (value) => set({ volatility: value }),

  rtpExact: [],
  setRtpExact: (rtpExact) => set({ rtpExact }),

  paylines: "",
  setPaylines: (value) => set({ paylines: value }),

  jackpotType: [],
  setJackpotType: (jackpotType) => set({ jackpotType }),

  languageSupport: [],
  setLanguageSupport: (language) => set({ languageSupport: language }),

  reels: "",
  setReels: (reels) => set({ reels }),

  rows: "",
  setRows: (rows) => set({ rows }),

  releaseDate: "",
  setReleaseDate: (releaseDate) => set({ releaseDate }),

  autoplay: null,
  setAutoplay: (autoplay) => set({ autoplay }),

  minStake: "",
  setMinStake: (minStake) => set({ minStake }),

  maxStake: "",
  setMaxStake: (maxStake) => set({ maxStake }),

  maxWin: "",
  setMaxWin: (maxWin) => set({ maxWin }),
}));
